import { FC } from 'react'
import { TableCard } from '../../../../components/Table/TableCard'
import { ComparacaoConteudo } from '../components/ComparacaoConteudo'
import { ComparacaoProtocoloHeading } from './components/ComparacaoProtocoloHeading'
import { ComparacaoProtocoloHeader } from './components/header/ComparacaoProtocoloHeader'
import { useComparacaoProtocolo } from './core/useComparacaoProtocolo'

/** Tela "Comparar versões" da empresa (T7a AC3). Padrão: comparar com a vigente. */
export const ComparacaoProtocoloPage: FC = () => {
  const { idProtocolo, idEmpresa, protocolo, outrasVersoes, comparacao, catalogo, com, setCom } =
    useComparacaoProtocolo()

  return (
    <>
      <ComparacaoProtocoloHeading
        protocolo={protocolo}
        idProtocolo={idProtocolo}
        idEmpresa={idEmpresa}
      />
      <TableCard>
        <ComparacaoProtocoloHeader outrasVersoes={outrasVersoes} com={com} onChange={setCom} />
        <ComparacaoConteudo comparacao={comparacao} catalogo={catalogo} />
      </TableCard>
    </>
  )
}
